import { Stack } from "@mui/material";
import "dayjs/locale/nl";
import { nanoid } from "nanoid";
import * as React from "react";
import { ITeamBoost } from "utils/api.interfaces";
import { getTeamBoostPerUser } from "../hooks/useTeam";
import ButtonBoosterUser from "./ButtonBoosterUser";
import ButtonBoostRemove from "./ButtonBoostRemove";
interface ButtonButtonBoostTeamProps {
  teamId: string;
  userId: string;
  refetch: () => Promise<any>;
}
const ButtonBoostContainer: React.FC<ButtonButtonBoostTeamProps> = ({
  userId,
  teamId,
  refetch,
}) => {
  const [isLoading, setIsLoading] = React.useState<Boolean>(false);
  const [boosts, setBoosts] = React.useState<ITeamBoost[] | null>(null);
  const [teamBoostId, setTeamBoostId] = React.useState<any | null>(null);
  React.useEffect(() => {
    if (teamId) {
      getTeamBoostPerUser(userId, teamId).then((res: any) => {
        setBoosts(res);
      });
    }
  }, [teamId]);

  return (
    <>
      {boosts?.map((boost: ITeamBoost) => {
        return (
          <div key={nanoid(6)}>
            <Stack
              direction="row"
              justifyContent="end"
              alignItems="center"
              alignContent="center"
            >
              <ButtonBoosterUser
                userId={boost.userId}
                expiresAtUtc={boost.expiresAtUtc}
                renew={boost.willRenew}
                variant="outlined"
              />
              <ButtonBoostRemove
                teamBoostId={boost.teamBoostId}
                refetch={refetch}
              />
            </Stack>
            <hr />
          </div>
        );
      })}
    </>
  );
};

export default ButtonBoostContainer;
